import AppProvider from "providers/AppProvider";
import React from "react";
import ReactDOM from "react-dom/client";
import BreakpointsProvider from "providers/BreakpointsProvider";
import SettingsPanelProvider from "providers/SettingsPanelProvider";
import { RouterProvider } from "react-router-dom";
import { router } from "Routes";
import ChatWidgetProvider from "providers/ChatWidgetProvider";
import { WhiteLabelProvider } from "contexts/WhiteLabelContext";
import { Toaster } from "react-hot-toast";

console.log("🚀 React App initializing...");

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("❌ Root element not found!");
} else {
  console.log("✅ Root element found:", rootElement);
  
  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log("✅ React root created");
    
    root.render(
      <>
        <AppProvider>
          <SettingsPanelProvider>
            <WhiteLabelProvider>
              <ChatWidgetProvider>
                <BreakpointsProvider>
                  <RouterProvider router={router} future={{v7_startTransition: true}} />
                </BreakpointsProvider>
              </ChatWidgetProvider>
            </WhiteLabelProvider>
          </SettingsPanelProvider>
        </AppProvider>
        <Toaster />
      </>
    );
    
    console.log("✅ React app rendered");
  } catch (error) {
    console.error("❌ Error initializing React app:", error);
  }
}
